import { render } from "./index.vue?vue&type=template&id=c9412592"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/design/components/templates/home-sub-banner-add/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c9412592"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c9412592', __exports__)) {
    api.reload('c9412592', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=c9412592", () => {
    api.rerender('c9412592', render)
  })

}


export default __exports__